export const hasEditSettingsPerm = (stripes) => stripes.hasPerm('ui-invoice.settings.all');
